interface MetricState {
  metricTitle: string;
  metricKey: string;
  sequence: number;
}

export const getRowHeight = (selectedMetrics: MetricState[]) => {
  return selectedMetrics.some((item) => item.metricKey === 'GOALS')
    ? '164px'
    : selectedMetrics.some((item) => item.metricKey === 'KEY_RESULTS')
    ? '130px'
    : undefined;
};

export const TOTAL_COUNT_METRICS = [
  'PR_MERGE',
  'PR_OPEN',
  'BUG_CLOSE',
  'BUG_OPEN',
  'MEETING_COUNT',
  'STORY_POINT_ASSIGNED',
  'STORY_POINT_COMPLETED',
  'TASK_OPEN',
  'TASK_CLOSE',
  'PR_COMMENT',
  'COMMIT_COUNT',
  'BUG_REPORTED',
  'ISSUE_REPORTED',
  'BUG_REOPENED',
];

export const getWorkBreakdownType = (metricName: string): string => {
  switch (metricName) {
    case 'WORK_BREAKDOWN_NEW_WORK':
      return 'newwork';
    case 'WORK_BREAKDOWN_REFACTOR':
      return 'refactor';
    case 'WORK_BREAKDOWN_HELP_OTHERS':
      return 'helpOthers';
    case 'WORK_BREAKDOWN_RE_WORK':
      return 'rework';
    default:
      return '';
  }
};

const dataPointMetricTitles = {
  BUG_IN_PROGRESS: 'Bug in Progress',
  TASK_IN_PROGRESS: 'Task in Progress',
  PR_MERGE: 'PR Merged',
  PR_OPEN: 'PR Opened',
  PR_REVIEW: 'PR Reviewed',
  COMMIT_COUNT: 'Commits',
  TASK_WORKED_UPON: 'Issue Contribution',
  BUG_WORKED_UPON: 'Bug Contribution',
  MEAN_TIME_TO_RECOVERY: 'MTTR',
  LEAD_TIME_FOR_CHANGE: 'Lead Time',
  CHANGE_FAILURE_RATE: 'Change Failure Rate',
  DEPLOYMENT_FREQUENCY: 'Deployment Frequency',
};

export const getMetricLabel = (metric: string): string => {
  return (
    (metric && typeof metric === 'string' && metric in dataPointMetricTitles
      ? dataPointMetricTitles[metric as keyof typeof dataPointMetricTitles]
      : '') || ''
  );
};
